import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { PsButtonTuner, PsNumericTuner } from 'stencilSetup';
import { EmployeeContributionBoxStyled } from './EditContributionDrawerStyled';
import { HandleAccordionValuesDto, ScheduledContributionDto } from 'enrollment/queries/useV3ContributionAmountQuery';

interface EmployeeContributionFormProps {
  id: number;
  payPeriod:ScheduledContributionDto;
  handleAccordionChangeValues:(id:number, handleAccordionAmounts:HandleAccordionValuesDto) => void;
}

export const EmployeeContributionForm = ({ payPeriod, id, handleAccordionChangeValues }: EmployeeContributionFormProps) => {
  const { t } = useTranslation('pages.financial');
  const [employeeSchduledContributionform, setemployeeSchduledContributionform] = useState<HandleAccordionValuesDto>({
    scheduled_subscriber_contribution: 0,
    scheduled_subscriber_lump_sum_contribution: 0,
    is_skip_pay_date: false,
  });
  const isScreenSmall = window.innerWidth < 821;
  const [deleteLumpsum, setDeleteLupsum] = useState(false);

  useEffect(() => {
    if (payPeriod) {
      setemployeeSchduledContributionform({
        scheduled_subscriber_contribution: Number(payPeriod.scheduled_subscriber_contribution),
        scheduled_subscriber_lump_sum_contribution: Number(payPeriod.scheduled_subscriber_lump_sum_contribution),
        is_skip_pay_date: payPeriod.is_skip_pay_date
      });
    }
  }, [payPeriod]);


  const handleAccordionChange = (e:any) => {
    let modifyContributionValues;
    const targetName = e.target.name;
    switch (targetName) {
      case "remove-lump-sum":
        setDeleteLupsum(true);
        modifyContributionValues = { ...employeeSchduledContributionform, scheduled_subscriber_lump_sum_contribution: Number(0).toFixed(2)};
        break;
      case "is_skip_pay_date":
        modifyContributionValues = { scheduled_subscriber_contribution: 0, scheduled_subscriber_lump_sum_contribution: 0, is_skip_pay_date: e.target.checked };
        break;
      default:
        modifyContributionValues = { ...employeeSchduledContributionform, [e.target.name]: Number(e.detail.value).toFixed(2) };
        break;
    }
    setemployeeSchduledContributionform(modifyContributionValues);
    handleAccordionChangeValues(id, modifyContributionValues);
  };
  return (
    <EmployeeContributionBoxStyled className={`pt-0 pb-3 pl-0 ${!isScreenSmall && "mx-2"}`}>
      <div className="row">
      <div className={isScreenSmall ? "col-sm-12 border-bottom pb-4" : "col-sm-8"}>
          <PsNumericTuner
            inputId={`employee-contribution-${id}`}
            id={`employee-contribution-sum-${id}`}
            data-testid={`employee-contribution-${id}`}
            label={t('editContribution.payPeriodContribution')}
            value={employeeSchduledContributionform.scheduled_subscriber_contribution}
            icon-left
            icon="currency-dollar"
            acceptDecimal={true}
            onPsChange={(e: any) => handleAccordionChange(e as any)}
            disabled={employeeSchduledContributionform.is_skip_pay_date}
            name="scheduled_subscriber_contribution"
          ></PsNumericTuner>
        </div>
      </div>
      {!deleteLumpsum && <div className="row mt-" id={`lumpsum-row-${id}`}>
        <div className={isScreenSmall ? "col-sm-12" : "col-sm-8"}>
          <PsNumericTuner
            data-testid={`employee-lumpsum-${id}`}
            id={`employee-lump-sum-${id}`}
            inputId={`employee-lumpsum-${id}`}
            label={t('editContribution.lumpSumContribution')}
            value={employeeSchduledContributionform.scheduled_subscriber_lump_sum_contribution}
            icon-left
            acceptDecimal={true}
            icon="currency-dollar"
            disabled={employeeSchduledContributionform.is_skip_pay_date}
            onPsChange={(e: any) => handleAccordionChange(e as any)}
            name="scheduled_subscriber_lump_sum_contribution"
          ></PsNumericTuner>
        </div>
        <div className={`text-center ${isScreenSmall ? "pt-3 col-sm-12 border-bottom pb-2" : "pt-5 col-sm-4 "}`}>
          <PsButtonTuner
            buttonId={`remove-lump-sum-${id}`}
            data-testid={`remove-lump-sum-${id}`}
            id={`remove-lump-sum-${id}`}
            level="tertiary"
            label={t('editContribution.remove')}
            icon="trash"
            otherData={[
              { attribute: 'name', value: 'remove-lump-sum' }
            ]}
            disabled={employeeSchduledContributionform.is_skip_pay_date}
            onClick={(e: any) => handleAccordionChange(e as any)}
          ></PsButtonTuner>
        </div>
      </div>}
      <div className="row mt-2">
        <div className="col toggle-switch">
          <ps-toggle-switch
            label="Skip pay period and the lump sum."
            id={`toggle-lump-sum-${id}`}
            data-testid={`toggle-lump-sum-${id}`}
            checked={employeeSchduledContributionform.is_skip_pay_date ? true : null}
            extra-class="mt-2 skip-pay-period px-2 text-dark"
            root-class="is_skip_pay_date"
            onClick={(e) => handleAccordionChange(e as any)}
            name="is_skip_pay_date"
          ></ps-toggle-switch>
        </div>
      </div>
    </EmployeeContributionBoxStyled>
  );
};

